// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavItem_wrapper__2BVjb","link":"NavItem_link__1hN5i","linkActive":"NavItem_linkActive__2COlE"};